import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import ZoomInIcon from 'grommet/components/icons/base/ZoomIn';
import Utils from 'medscape/utils';

export default class ZoomButton extends React.Component {
  constructor(props){
    super(props);
    this.state = {
    }
  }
  componentDidMount(){

  }

  componentWillUnmount(){  
  }

  render() {
    if(this.props.icon.length==0){
      return(
        <button className="zoom-button" onClick={this.props.onClick}><ZoomInIcon /></button>
      )
    }
    else{
      return(
        <button className="zoom-button" onClick={this.props.onClick} dangerouslySetInnerHTML={iconHtml}></button>
      )
    }

  }
}

ZoomButton.propTypes={
    "onClick": React.PropTypes.func,
    "icon": React.PropTypes.string
}
ZoomButton.defaultProps={
  "onClick": ()=>{},
  "icon": ""
}



// WEBPACK FOOTER //
// ./src/app/zoom-images/zoom-button.jsx